"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const OutlinedInput_1 = __importDefault(require("@material-ui/core/OutlinedInput"));
const uuid_1 = require("uuid");
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const mapProps = (_a) => {
    var { type = 'text', required = false, autocomplete = true, disableBrowserAutocorrect = false } = _a, props = __rest(_a, ["type", "required", "autocomplete", "disableBrowserAutocorrect"]);
    const autoCorrectString = disableBrowserAutocorrect ? 'off' : 'on';
    const autoCompleteString = autocomplete ? 'on' : 'off';
    const inputProps = {
        'aria-labelledby': props.ariaLabelledby,
        'aria-describedby': props.ariaDescribedby,
        'aria-required': required,
    };
    return {
        type,
        name: props.name,
        required,
        placeholder: props.placeholder,
        disabled: props.disabled,
        readOnly: props.readonly,
        error: props.invalid,
        autoComplete: autoCompleteString,
        autoCorrect: autoCorrectString,
        autoFocus: props.autofocus,
        inputProps,
    };
};
/**
 * Enables users to input text in a single-line control.
 */
const Input = (_a) => {
    var { onChange } = _a, props = __rest(_a, ["onChange"]);
    const [showClearInputButton, setShowClearInputButton] = react_1.default.useState(false);
    const [inputValue, setInputValue] = react_1.default.useState(props.value === undefined ? '' : props.value);
    const id = props.controlId || uuid_1.v4();
    react_1.useEffect(() => {
        setInputValue(props.value === undefined ? '' : props.value);
    }, [props.value]);
    const handleChange = react_1.useCallback((value) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        setShowClearInputButton(true);
        setInputValue(value);
    }, [onChange]);
    const testId = props['data-testid'] || `input-${props.type || 'text'}`;
    const clearSearchInput = react_1.useMemo(() => (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
        react_1.default.createElement(Clear_1.default, { color: "action", "data-testid": `${testId}-clear-input`, onClick: () => {
                setShowClearInputButton(false);
                setInputValue('');
                handleChange('');
            } }))), [testId, handleChange]);
    return (react_1.default.createElement(OutlinedInput_1.default, Object.assign({ id: id, fullWidth: true }, mapProps(props), { startAdornment: props.type === 'search' && (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
            react_1.default.createElement(Search_1.default, { color: "action" }))), endAdornment: props.type === 'search' && showClearInputButton && clearSearchInput, value: inputValue, onChange: (e) => handleChange(e.target.value), onBlur: props.onBlur, onFocus: props.onFocus, "data-testid": testId })));
};
exports.default = Input;
//# sourceMappingURL=index.js.map